import { reactive } from "vue";

import { assetUrl } from "../api/client.js";

export const i18n = reactive({ lang: "en", catalog: {}, fallback: {} });
const pending = new Map();

async function catalog(lang) {
  if (pending.has(lang)) return pending.get(lang);
  const request = fetch(assetUrl(`/assets/i18n/${lang}.json?v=20260911-2`), {
    credentials: "same-origin",
  }).then((response) => {
    if (!response.ok) throw new Error(`Unable to load ${lang} translations.`);
    return response.json();
  }).finally(() => pending.delete(lang));
  pending.set(lang, request);
  return request;
}

export async function setI18nLanguage(value) {
  const lang = ["en", "zh", "ja"].includes(value) ? value : "en";
  const [selected, fallback] = await Promise.all([
    catalog(lang).catch(() => ({})),
    lang === "en" ? Promise.resolve({}) : catalog("en").catch(() => ({})),
  ]);
  i18n.lang = lang;
  i18n.catalog = selected;
  i18n.fallback = fallback;
  document.documentElement.lang = lang;
}

export function translate(key, values) {
  let output = i18n.catalog[key] ?? i18n.fallback[key] ?? key;
  if (values && typeof values === "object") {
    for (const [name, value] of Object.entries(values)) {
      output = output.replaceAll(`{${name}}`, String(value));
    }
  }
  return output;
}
